const getOrientation = () => {
	const mediaQueryList = window.matchMedia('(orientation:portrait)');
	const isPortrait = mediaQueryList.matches;

	return [isPortrait ? 'portrait' : 'landscape', mediaQueryList] as const;
};

const getIframeTopOffset = (hasRegulationHeader?: boolean, hasInGameToolbar?: boolean) => {
	const [orientation] = getOrientation();

	return `calc(${hasRegulationHeader ? 'var(--regulationHeight)' : '0px'} + ${
		hasInGameToolbar && orientation === 'portrait' ? 'var(--inGameToolbarHeight)' : '0px'
	})`;
};

const getIframeLeftOffset = (hasInGameToolbar?: boolean) => {
	const [orientation] = getOrientation();
	return hasInGameToolbar && orientation === 'landscape'
		? 'calc(env(safe-area-inset-left) + var(--inGameToolbarWidth))'
		: '0px';
};

const gettoolbarLeftMargin = (orientation?: string) => {
	return orientation === 'landscape' ? '0 calc(env(safe-area-inset-left) + var(--inGameToolbarWidth))' : '0px';
};

const orientationChangeHandler = (
	isDesktop?: boolean,
	hasRegulationHeader?: boolean,
	hasInGameMobileToolbar?: boolean,
	target?: Element | null
) => {
	if (!isDesktop) {
		const leftOffset = getIframeLeftOffset(hasInGameMobileToolbar);
		const topOffset = getIframeTopOffset(hasRegulationHeader, hasInGameMobileToolbar);

		target?.setAttribute(
			'style',
			`
				width: calc(100% - ${leftOffset} - env(safe-area-inset-right));
				height: calc(100% - ${topOffset});
				position: fixed;
				top: ${topOffset};
				left: ${leftOffset};
			`
		);
	}
};

const getIframeBottomOffset = (hasBottomBar?: boolean) => {
	const [orientation] = getOrientation();

	if (orientation === 'portrait' && hasBottomBar) {
		return `var(--inGameBottomBarHeight)`;
	}

	return '0px';
};

export {
	getOrientation,
	getIframeTopOffset,
	getIframeLeftOffset,
	gettoolbarLeftMargin,
	orientationChangeHandler,
	getIframeBottomOffset
};
